import { cx } from '@/Ship/Helpers/cssClass'

import styles from './RouteStrip.module.css'

interface RouteStripProps {
    from: string | null | undefined
    to: string | null | undefined
    /** marking — жовта осьова лінія (поточне завдання), default — нейтральна */
    tone?: 'marking' | 'default'
    size?: 'md' | 'lg'
}

/**
 * Маршрут завдання «звідки → куди» у вигляді дороги: наповнене коло — пункт
 * навантаження, квадратний прапорець — пункт розвантаження, між ними штрихова
 * осьова. Один і той самий елемент у картці списку й у деталях завдання.
 */
export const RouteStrip = ({ from, to, tone = 'default', size = 'md' }: RouteStripProps) => (
    <div
        className={`${cx(styles, 'strip')}${tone === 'marking' ? ` ${cx(styles, 'strip--marking')}` : ''}${size === 'lg' ? ` ${cx(styles, 'strip--lg')}` : ''}`}
        data-testid="route-strip"
    >
        <div className={cx(styles, 'rail')} aria-hidden="true">
            <span className={cx(styles, 'from')} />
            <span className={cx(styles, 'to')} />
        </div>
        <div className={cx(styles, 'stop')}>
            <span className={cx(styles, 'stopLabel')}>Навантаження</span>
            <span className={`${cx(styles, 'stopTitle')}${from ? '' : ` ${cx(styles, 'stopTitle--empty')}`}`}>
                {from || 'Не вказано'}
            </span>
        </div>
        <div className={cx(styles, 'stop')}>
            <span className={cx(styles, 'stopLabel')}>Розвантаження</span>
            <span className={`${cx(styles, 'stopTitle')}${to ? '' : ` ${cx(styles, 'stopTitle--empty')}`}`}>
                {to || 'Не вказано'}
            </span>
        </div>
    </div>
)
